import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Grid,
  Box,
  TextField,
  MenuItem,
  Typography,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  TableBody,
  useMediaQuery,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Autocomplete from "@mui/material/Autocomplete";
import apiRequest from "../../functions/api";
import { useTheme } from "@mui/material/styles";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { useMessage } from "../../context/message-context";
import { DateTextField } from "../lib";
import MessageBox from "../shared/components/MessageBox";
import Layout from "../shared/components/LayoutComponent";
import StrassenAutocomplete from "../StrassenAutocomplete/StrassenAutocomplete";
import { ContentCopy } from "@mui/icons-material";

function MasterDataAdress(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [altstr, setAltStr] = useState("");
  const [althnr, setAltHnr] = useState("");
  const [altplz, setAltPlz] = useState("");
  const [altort, setAltOrt] = useState("");
  const [altland, setAltLand] = useState("");
  const [altbl, setAltBL] = useState("");
  const [vorsenden, setVorSenden] = useState(false);
  const [zeitraum, setZeitraum] = useState("");
  const [land, setLand] = useState("");
  const [landObj, setLandObj] = useState(null);
  const [plz, setPLZ] = useState("");
  const [bundesland, setBundesland] = useState("");
  const [bundeslandkey, setBundeslandKey] = useState("");
  const [ort, setOrt] = useState("");
  const [orte, setOrte] = useState([""]);
  const [ortzaehler, setOrtZaehler] = useState("");
  const [hnr, setHNR] = useState("");
  const [strasse, setStrasse] = useState([]);
  const [str, setStr] = useState("");
  const [strObj, setStrObj] = useState(null);
  const [laender, setLaender] = useState([]);
  const [beantragt, setBeantragt] = useState("");
  const [msgbox, setMsgBox] = useState(false);
  const { accessToken, client, bearbeitung, daten, reloadDaten } = props;
  const [stateReload, setStateReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [issending, setIsSending] = useState(false);
  const { hideMessage, showErrorMessage, showSuccessMessage } = useMessage();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [alteDaten, setAlteDaten] = useState([]);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (daten) {
      setAlteDaten(daten);
      setAltStr(daten.str);
      setAltHnr(daten.hnr);
      setAltPlz(daten.plz);
      setAltOrt(daten.ort);
      setAltLand(daten.land);
      if (getLenNoSpaces(daten.land) === 0) {
        setAltLand("Deutschland");
      }
      setAltBL(daten.bl);
      if (daten.beantragt) {
        setBeantragt(daten.beantragt);
        if (daten.beantragt.status !== "") {
          setMsgBox(true);
        }
      }
    }

    // HoleDaten();
    // eslint-disable-next-line
  }, [daten]);

  const HoleDaten = () => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "LWEB02",
      statement: "HOLE_ALT_ADRESSE",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, datencb, errorCb);
  };
  const datencb = (response) => {
    if (response.status === 200) {
      setAlteDaten(response.data);
      setAltStr(response.data.str);
      setAltHnr(response.data.hnr);
      setAltPlz(response.data.plz);
      setAltOrt(response.data.ort);
      setAltLand(response.data.land);
      if (getLenNoSpaces(response.data.land) === 0) {
        setAltLand("Deutschland");
      }
      setAltBL(response.data.bl);
      if (response.data.beantragt) {
        setBeantragt(response.data.beantragt);
        if (response.data.beantragt.status !== "") {          
          setMsgBox(true);
        }
      }
      setIsLoading(false);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const daten_speichern = () => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "LWEB02",
      statement: "SPEICHERE_AENDERUNG",
      plz: plz,
      land: land,
      ortName: land === "   " ? orte.find((e) => e.key === ort).ort : ort,
      ort: ort,
      str: str,
      hnr: hnr,
      bundesland: bundeslandkey,
      zr: zeitraum,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, speichercb, errorCb);
  };
  const speichercb = (response) => {
    if (response.status === 200) {
      if (response.data.message === "Ok") {
        // navigate(-1);
        showSuccessMessage(t("Adresse geändert"));
        setDialogOpen(false)
reloadDaten()
      } else {
        showErrorMessage(response.data.message);
      }
      setIsLoading(false);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const ladestrasse = () => {
    setIsSending(true);
    setHNR("");
    const payload = {
      mandant: client,
      program: "LWEB02",
      statement: "HOLE_STRASSEN",
      plz: plz,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, strassecb, errorCb);
  };
  const strassecb = (response) => {
    if (response.status === 200) {
      if (response.data.strasse) {
        setStrasse(response.data.strasse);
      } else {
        setStrasse([]);
      }
      setIsSending(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const ladeOrte = () => {
    setOrt("");
    setIsSending(true);
    const payload = {
      mandant: client,
      program: "LWEB02",
      statement: "HOLE_ORTE",
      plz: plz,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, ortecb, errorCb);
  };
  const ortecb = (response) => {
    if (response.status === 200) {
      if (response.data.orte) {
        setOrte(response.data.orte);
        setOrtZaehler(response.data.ort_zaehler);
        setOrt(response.data.orte[0].key);
        setBundesland(response.data.orte[0].bl_name);
        setBundeslandKey(response.data.orte[0].bl_key);
      } else {
        setOrte([]);
        setOrtZaehler("0");
      }
      setIsSending(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const errorCb = () => {
    setIsSending(false);
    setIsLoading(false);
    showErrorMessage(t("Keine Internetverbindung"));
  };
  const ladeLaender = () => {
    setIsSending(true);
    const payload = {
      mandant: client,
      program: "LWEB02",
      statement: "HOLE_LAENDER",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, laenderCb, errorCb);
  };
  useEffect(() => {
    ladeLaender();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (land === "   ") {
      plz.length === 5 ? ladeOrte() : setOrt("");
    }
    // eslint-disable-next-line
  }, [plz]);
  useEffect(() => {
    land === "   " && plz.length === 5 && ladestrasse();
    // eslint-disable-next-line
  }, [ort]);
  const laenderCb = (response) => {
    if (response.status === 200) {
      if (response.data.land) {
        setLaender(response.data.land);
        setZeitraum(response.data.zeitraum);
      } else {
        setLaender([]);
      }
      setIsSending(false);
      hideMessage(null);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  const messageBoxResult = (result) => {
    if (result === "NO") {
      setDialogOpen(false);
      setStateReload(!stateReload);
      // HoleDaten()
    }
    setMsgBox(false);
  };
  const getLenNoSpaces = (str) => {
    return str?.replace(/\s+/g, "").length;
  };
  if (msgbox && dialogOpen) {
    return (
      <MessageBox
        open={msgbox}
        handleResponse={messageBoxResult}
        buttons="YESNO"
        text={["Wollen Sie diese Änderung überschreiben ?"]}
        title={t("Es ist bereits eine Adressänderung vorhanden")}
        onClose={() => setMsgBox(false)}
      />
    );
  }

  const eingabeStraße = () => {
    return (
      <Fragment>
        <Grid item xs={12}>
          <Box p={1}>
            <TextField
              id="HNR"
              label={t("Hausnummer")}
              value={hnr}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(event) => setHNR(event.target.value)}
              variant="outlined"
              fullWidth
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box p={1}>
            {land === "   " ? (
              <StrassenAutocomplete
                id="Straße"
                onChange={(event, newValue) => {
                  setStr(newValue?.strasse);
                  setStrObj(newValue);
                }}
                value={strObj}
                options={strasse}
                noOptionsText={ort !== "" ? t("Keine Einträge gefunden") : t("Geben Sie eine PLZ ein um Strassennamen zu laden")}
                getOptionLabel={(option) => option.strasse}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("Straße")}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
              />
            ) : (
              <TextField
                id="Straße"
                variant="outlined"
                onChange={(event) => setStr(event.target.value)}
                label={t("Straße")}
                value={str}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
              />
            )}
          </Box>
        </Grid>
      </Fragment>
    );
  };
  const orteingabe = () => {
    return (
      <Fragment>
        <Grid item xs={12}>
          <Box p={1}>
            <TextField
              id="ORT"
              label={t("Ort")}
              value={ort}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(event) => setOrt(event.target.value)}
              variant="outlined"
              fullWidth
            />
          </Box>
        </Grid>
      </Fragment>
    );
  };
  const mehrere_orte = orte.map((element) => {
    return <MenuItem value={element.key}>{element.ort}</MenuItem>;
  });
  const ortauswahl = () => {
    return (
      <Fragment>
        <Grid item xs={12}>
          <Box p={1}>
            {ortzaehler === "0" ? (
              <Box p={2}>
                <Typography>{t("Zu dieser Postleitzahl wurden keine Orte gefunden.")}</Typography>
              </Box>
            ) : (
              <TextField
                select
                variant="outlined"
                label={t("Ort")}
                value={ort}
                onChange={(event) => setOrt(event.target.value)}
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={ortzaehler === "1"}
              >
                {mehrere_orte}
              </TextField>
            )}
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box p={1}>
            <TextField variant="outlined" label={t("Bundesland")} fullWidth value={bundesland} disabled />
          </Box>
        </Grid>
      </Fragment>
    );
  };
  const postleitZahl = () => {
    return (
      <Grid item xs={12}>
        <Box p={1}>
          <TextField
            id="PLZ"
            label={t("Postleitzahl")}
            type="number"
            value={plz}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(event) => {
              setPLZ(event.target.value);
              if (land === "   ") {
                setStr("");
                setStrObj(null);
                setOrte([]);
                setOrt("");
                setBundesland("");
                setStrasse([]);
              }
            }}
            variant="outlined"
            fullWidth
          />
        </Box>
      </Grid>
    );
  };
  const setzeLand = (newValue) => {
    setPLZ("");
    setStr("");
    setHNR("");
    setStrObj(null);
    setOrte([]);
    setOrt("");
    if (newValue !== null) {
      setLandObj(newValue);
      setLand(newValue.key);
    } else {
      setLand("");
      setLandObj(null);
    }
  };
  const dialogClose = () => {
    setDialogOpen(false);
  };
  const handleCopy = (copyData) => {
    navigator.clipboard.writeText(copyData);
    showSuccessMessage("Kopieren erfolgreich");
  };

  if (isLoading) {
    return <LoadingComponent />;
  }
  {
    console.log(daten?.beantragt?.status);
  }
  return (
    <Grid item xs={12}>
      <Paper>
        {daten?.beantragt?.status && (
          <>
            <Typography color={"red"}>{daten.beantragt.status === "A" ? "Änderung bereits beantragt" : "Änderung genehmigt und zur Übernahme vorgemerkt:"}</Typography>
            <Typography>{daten.beantragt.land}</Typography>
            <Typography color={"red"}>
              {daten.beantragt.STR} {daten.beantragt.HNR} , {daten.beantragt.PLZ} {daten.beantragt.ORT}
            </Typography>
          </>
        )}
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow key="adressdaten">
                <TableCell>
                  <Typography>{t("Aktuelle Adressdaten")}</Typography>
                </TableCell>
                <TableCell></TableCell>
                <TableCell align="right">
                  {bearbeitung && (
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();

                        if (daten.beantragt?.status && daten.beantragt.status !== "A") {
                          showErrorMessage(
                            t(
                              "Es ist bereits eine Änderung in Bearbeitung. Bitte warten Sie, bis diese übernommen wurde, bevor Sie einen neuen Änderungsantrag stellen"
                            )
                          );
                        } else {
                          setDialogOpen(true);
                        }
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.entries(alteDaten).map((item) => {
                var name = "";
                var data = "";
                switch (item[0]) {
                  case "land":
                    name = "Land";
                    data = altland;
                    break;
                  case "ort":
                    name = "Ort";
                    data = item[1];
                    break;
                  case "plz":
                    name = "Postleitzahl";
                    data = item[1];
                    break;
                  case "str":
                    name = "Straße";
                    data = item[1] + " " + althnr;
                    break;

                  default:
                    return;
                }

                return (
                  <TableRow key={name}>
                    <TableCell>
                      <Typography>{t(name)}</Typography>
                      {fullScreen && <Typography variant="body2">{data}</Typography>}
                    </TableCell>
                    <TableCell width="125%" align="right">
                      {!fullScreen && <Typography variant="body2">{data}</Typography>}
                    </TableCell>
                    <TableCell align="right">
                      <IconButton color="primary" onClick={() => handleCopy(data)}>
                        <ContentCopy />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog
          sx={{ "& .MuiDialog-paper": { width: "70%", maxHeight: 800 } }}
          maxWidth="md"
          open={dialogOpen}
          fullWidth={fullScreen}
          onClose={() => dialogClose()}
        >
          <DialogTitle>{t("Adresse ändern")}</DialogTitle>
          <DialogContent dividers>
            <Layout fullWidth>
              {!vorsenden && (
                <Grid container>
                  <Grid item xs={12}>
                    <Box p={1}>
                      <Typography align={"center"}>{t("bisherige Adresse:")}</Typography>
                      <Typography align={"center"}>{altstr + " " + althnr}</Typography>
                      <Typography align={"center"}>{altplz + " " + altort}</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box p={1}>
                      <DateTextField
                        id="date"
                        label={t("Wann soll die Änderung erfolgen?")}
                        variant="outlined"
                        value={zeitraum}
                        onChange={(event) => {
                          setZeitraum(event.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        fullWidth
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box p={1}>
                      <Autocomplete
                        openOnFocus
                        id="combo-box-demo"
                        onChange={(event, newValue) => {
                          setzeLand(newValue);
                        }}
                        value={landObj}
                        options={laender}
                        getOptionSelected={(option, value) => option.key === value}
                        noOptionsText={t("Länder konnten nicht geladen werden")}
                        getOptionLabel={(option) => option.title}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t("Land")}
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        )}
                      />
                    </Box>
                    {laender.length === 0 && (
                      <Box pb={1}>
                        <Grid container justifyContent="flex-start" alignItems="center">
                          <Grid item>
                            <Box pl={2}>
                              <Typography>{t("Länderauswahl konnte nicht geladen werden.")}</Typography>
                            </Box>
                          </Grid>
                          <Grid item>
                            <Box pl={2}>
                              <Button variant="contained" color="primary" onClick={ladeLaender}>
                                {t("Erneut versuchen")}
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                  </Grid>
                  {postleitZahl()}
                  {land === "   " ? ortauswahl() : orteingabe()}
                  {eingabeStraße()}
                  <Grid item xs={12}>
                    <Grid container justifyContent={"flex-end"}>
                      <Grid item>
                        <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                          <Button variant="contained" fullWidth onClick={() => setDialogOpen(false)}>
                            {t("Zurück")}
                          </Button>
                          <Button variant="contained" color="primary" disabled={str === "" || ort === ""} fullWidth onClick={() => setVorSenden(true)}>
                            {t("Weiter")}
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {vorsenden && (
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <Box p={1}>
                      <Typography color="primary" align="left">
                        {t("Bisherige Adresse")}
                      </Typography>
                      <Typography align="left">{altstr + " " + althnr}</Typography>
                      <Typography align="left">{altplz + " " + altort}</Typography>
                      <Typography align="left">{altbl}</Typography>
                      <Typography align="left">{laender.find((element) => element.key === altland)?.title}</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box p={1}>
                      <Typography color="primary" align="left">
                        {t("Neue Adresse")}
                      </Typography>
                      <Typography align="left">{str + " " + hnr}</Typography>
                      <Typography align="left">{land === "   " ? plz + " " + orte.find((element) => element.key === ort)?.ort : plz + " " + ort}</Typography>
                      <Typography align="left">{land === "   " && orte.find((element) => element.key === ort)?.bl_name}</Typography>
                      <Typography align="left">{laender.find((element) => element.key === land)?.title}</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container justifyContent="flex-end">
                      <Grid item>
                        <Box p={1}>
                          <Button fullWidth color="primary" variant="text" onClick={() => setVorSenden(false)}>
                            {t("Zurück")}
                          </Button>
                        </Box>
                      </Grid>
                      <Grid item>
                        <Box p={1}>
                          <Button variant="contained" color="primary" fullWidth onClick={() => daten_speichern()}>
                            {t("Speichern")}
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              <Backdrop
                open={issending}
                style={{
                  color: theme.palette.common.white,
                  zIndex: theme.zIndex.drawer + 1,
                }}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            </Layout>
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </Paper>
    </Grid>
  );
}
export default MasterDataAdress;
